import {NotificationService} from "../../services/NotificationService";
import {ReaderService} from "../../services/ReaderService";
import {MapSiteService} from "../../services/MapSiteService";
import {Reader} from "../../entities/Reader";
import {MapSite} from "../../entities/MapSite";

export class CmdCenterEditSiteModel {
    mapSite:MapSite;
    mapSiteID:number;
    available:Reader[];
    selectedAvailable:Reader[];
    assigned:Reader[];
    selectedAssigned:Reader[];
    static $inject = ['$q','MapSiteService','ReaderService','NotificationService'];
    constructor(public $q:ng.IQService,
                public mapSiteService:MapSiteService,
                public readerService:ReaderService,
                public notificationService:NotificationService)
    {
    }

    init(mapSiteId:number):ng.IPromise<any> {
        this.available = [];
        this.assigned = [];
        this.mapSiteID = mapSiteId;
        var mainPromise:ng.IPromise<any> = null;
        if(isNaN(this.mapSiteID))
            mainPromise = this.$q.when<MapSite>(null);
        else
            mainPromise = this.mapSiteService.get(this.mapSiteID);
        return this.$q.all([mainPromise,this.readerService.getGateways()]).then((data:any)=> {
                this.mapSite = data[0] == null ? new MapSite() : data[0];
                var allReaders = data[1];
                for(var i=0;i<allReaders.length;i++){
                    var reader = allReaders[i];
                    if(reader.mapSiteID != null && reader.mapSiteID == mapSiteId)
                        this.assigned.push(reader);
                    else
                        this.available.push(reader);
                }
                this.selectedAvailable = this.available.length > 0 ? [this.available[0]] : [];
                this.selectedAssigned = this.assigned.length > 0 ? [this.assigned[0]] : [];
        });
    }
    add(){
        if(this.selectedAvailable.length == 0)
            return;
        var tempAvailable = this.selectedAvailable[0];
        var availableIndex = this.available.indexOf(tempAvailable);
        this.available.splice(availableIndex, 1);
        this.assigned.push(tempAvailable);
        this.selectedAvailable = this.available.length > 0 ? [this.available[0]] : [];
    }
    remove(){
        if(this.selectedAssigned.length == 0)
            return;
        var assigned = this.selectedAssigned[0];
        var assignedIndex = this.assigned.indexOf(assigned);
        this.assigned.splice(assignedIndex, 1);
        this.available.push(assigned);
        this.selectedAssigned = this.assigned.length > 0 ? [this.assigned[0]] : [];
    }
    save():ng.IPromise<any>{
        if(this.mapSite.name == null || this.mapSite.name.length == 0)
        {
            this.notificationService.notify("Please enter a name before saving");
            return this.$q.when<boolean>(false);
        }
        var mainPromise:ng.IPromise<any> = null;
        if(isNaN(this.mapSiteID))
            mainPromise = this.mapSiteService.insert(this.mapSite);
        else
            mainPromise = this.mapSiteService.update(this.mapSite);
        var readerPromises:ng.IPromise<any>[] = [];
        return mainPromise.then((data)=>{
            if(this.mapSiteID == null) {
                this.mapSiteID = data;
                this.mapSite.id = data;
            }
            $.each(this.assigned, (i, val)=> {
                val.mapSiteID = this.mapSite.id;
                readerPromises.push(this.readerService.update(val));
            });
            $.each(this.available,(i, val)=> {
                if (val.mapSiteID == this.mapSite.id)
                    val.mapSiteID = null;
                readerPromises.push(this.readerService.update(val));
            });
            return this.$q.all(readerPromises);
        });
    }
}
